<template>
  <div>
    <b-dialog :mshow="mergeRuleShow" height="100%">
      <div class="beast-login-warp merge">
        <div class="merge-main">
          <img  class="close" @click="close" src="./assets/close.png">
          <div class="login-head">
            <img src="./assets/wtf.png"></img>
            <p class="title" >相关说明</p>
            <div class="line"></div>
          </div>

          <div class="login-main">
            <div class="merge-rule">
              <div>
                <p>Q：账户合并会牵涉哪些项目合并？</p>
                <p>A：会员的基础信息、等级信息、所有历史订单以及账户内所有的会员福利等，合并流程不可逆。</p>
              </div>
              <div>
                <p>Q：生日信息的合并方法？</p>
                <p>A：会以当前登录账号为准；若当前账户生日为空，则取子账号生日。</p>
              </div>
              <div>
                <p>Q：合并后的会员等级怎么计算？</p>
                <p>A：会员等级和有效期会取多个账户中等级较高的一个。如果合并后，12个月的总消费满足升级条件，会在次日统一升级。</p>
              </div>
              <div>
                <p>Q：会员账户内的优惠券，以及相关权益如何合并？</p>
                <p>A：已领取的所有优惠券和权益都会进行合并；可在个人中心内查看并使用。</p>
              </div>
              <div>
                <p>Q：账户内还有未领取的会员礼包？</p>
                <p>A：如果还有未领取的会员礼包，我们会将礼包统一发放至您当前登录账户中。</p>
              </div>
              <div>
                <p>Q：被合并的账户不是我的？</p>
                <p>A：可以通过在线客服反映，我们会尽快核实并处理。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-dialog>
  </div>
</template>

<script>
import Slide from '@/components/slide'
import api from './api.js'
import BDialog from '@/components/dialog/login-dialog.vue'

export default {
  components:{
    Slide,
    BDialog
  },
  data (){
    return {
    }
  },
  props: {
    mergeRuleShow: {
      default: true
    }
  },
  methods: {
    close: function (){
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="stylus">
@import './index-old.styl'

</style>



// WEBPACK FOOTER //
// merge-rule.vue?a8222702